module.exports = __webpack_public_path__ + "img/approved-symbol.2b2ce202.svg";